import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00e5e735"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "id_result flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "신규 회원가입이 완료되었습니다.", -1))
const _hoisted_3 = { class: "center" }
const _hoisted_4 = { class: "id" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "윈윈포스 회원이 되신 것을 환영합니다!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, "'" + _toDisplayString(_ctx.id) + "' 님", 1),
      _hoisted_5
    ]),
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loginPageMove()))
    }, "로그인 하기")
  ]))
}